import React from "react";
import {useSelector} from "react-redux";
import Facet from "../../components/Facet/Facet";
import styles from "./FacetsContainer.scss";

const FacetsContainer = (props) => {
    const {weight} = props;
    const newFilterState = useSelector(state => state.newFilterReducer);
    const isMobile = newFilterState.isMobile;
    let facetsR = [];

    const activeGroup = newFilterState.activeGroup;
    const availableGroups = newFilterState.availableGroups;

    let myStyle = {width: '100%'};
    if (weight) {
        myStyle.order = weight;
    }

    let overview;
    const totalItems = newFilterState.totalItems;
    const overviewStyle = { // For some quacking reason classes do not work here! Not idea why!!!!!
        'textAlign': 'center',
        'fontStyle': 'italic'
    };
    // className Y U NO WORK?????
    if (totalItems === 1) {
        overview = <div className={styles.resultsoverview} style={overviewStyle}>Søket ditt har ett resultat</div>;
    }
    else if (totalItems > 1) {
        overview = <div className={styles.resultsoverview} style={overviewStyle}>Søket ditt har {totalItems} resultater</div>;
    }
    else {
        overview = <div className={styles.resultsoverview} style={overviewStyle}>Søket ditt har ingen resultater</div>;
    }

    if (!activeGroup) {
        return (<></>);
    }

    if (availableGroups[activeGroup] !== undefined) {
        if (availableGroups[activeGroup].children !== undefined) {
            const myChildren = availableGroups[activeGroup].children;
            for (const [key, item] of Object.entries(myChildren)) {
                if (item.count !== 0) {
                    facetsR.push(<Facet key={key} value={item.value} count={item.count} facetName={item.facetName}/>);
                }
            }
        }
    }
    return (
        <div className={styles.wrapper} style={myStyle}>
            {!isMobile && overview}
            {facetsR}
        </div>
    );
};

export default FacetsContainer;
